import createManagementPageLifecycle from "@shared/createManagementPageLifecycle.cjs";

export default createManagementPageLifecycle({
  navbar: "4",
  navbarHook: "mounted",
  loadMethods: ["loadReviews"],
});
